/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClockPlay = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m23 19.464-6 3.464V16z" />
        <path d="M12 2c5.523 0 10 4.477 10 10 0 1.167-.2 2.29-.57 3.333l-1.885-.666c.294-.833.455-1.73.455-2.667a8 8 0 1 0-5.333 7.545l.666 1.886A9.986 9.986 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2z" />
        <path d="m13 11.382 3.447 1.724-.894 1.788L11 12.618V6h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgClockPlay as ClockPlay };
